import React, { useState, Fragment } from "react";
import Login from "./Login";
import Signup from "./Signup";

// Bảng màu sang trọng đồng bộ với App
const colors = {
  bgApp: '#FCFBF7',      // Nền Kem/Ngà
  bgCard: '#FFFFFF',     // Nền Trắng tinh
  textMain: '#3C2A1A',   // Nâu Cà phê
  textMuted: '#8B7D6B',  // Nâu Taupe
  borderColor: '#E9E4DB',// Viền Vàng mờ
  activeMenu: '#C5A075', // Vàng Đồng brand
};

// Custom CSS Animations cho Auth
const authStyles = `
  .auth-wrapper {
    background-color: ${colors.bgApp};
    min-height: 100vh;
    font-family: 'Inter', system-ui, sans-serif;
  }
  .auth-card {
    background-color: ${colors.bgCard};
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(60, 42, 26, 0.05);
    border: 1px solid ${colors.borderColor};
  }
  .auth-input {
    background-color: ${colors.bgApp};
    border: 1px solid ${colors.borderColor};
    color: ${colors.textMain};
    border-radius: 12px;
    padding: 12px 16px;
    transition: all 0.3s ease;
  }
  .auth-input:focus {
    outline: none;
    border-color: ${colors.activeMenu};
    box-shadow: 0 0 0 4px rgba(197, 160, 117, 0.15);
    background-color: #ffffff;
  }
  .auth-input::placeholder {
    color: #b5ac9d;
  }
  .auth-btn {
    background-color: ${colors.activeMenu};
    color: #ffffff;
    border-radius: 12px;
    padding: 14px;
    border: none;
    font-weight: 700;
    letter-spacing: 1px;
    transition: all 0.3s ease;
  }
  .auth-btn:hover:not(:disabled) {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(197, 160, 117, 0.3);
  }
  .auth-btn:disabled {
    background-color: ${colors.textMuted};
    cursor: not-allowed;
  }
  .fade-enter {
    animation: fade-in-up 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  }
  @keyframes fade-in-up {
    0% { opacity: 0; transform: translateY(15px); }
    100% { opacity: 1; transform: translateY(0); }
  }
  .auth-tab {
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
  }
`;

const LoginSignup = () => {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <Fragment>
      <style>{authStyles}</style>
      <div className="auth-wrapper d-flex justify-content-center align-items-center py-5">
        <div className="auth-card p-4 p-md-5 w-100" style={{ maxWidth: '480px', margin: '0 20px' }}>

          {/* Header: Logo & Subtitle */}
          <div className="text-center mb-5">
            <h2 className="fw-bold mb-2" style={{ letterSpacing: "4px", color: colors.textMain }}>
              HANDDN
            </h2>
            <p className="small mb-0" style={{ color: colors.textMuted }}>
              Hệ thống quản trị xưởng da thủ công
            </p>
          </div>

          {/* Toggle Tabs (Login / Signup) cực kỳ mượt mà */}
          <div className="d-flex p-1 mb-4 rounded-4" style={{ backgroundColor: colors.bgApp, border: `1px solid ${colors.borderColor}` }}>
            <div
              onClick={() => setIsLogin(true)}
              className={`auth-tab flex-fill text-center py-2 fw-bold small`}
              style={{
                backgroundColor: isLogin ? '#ffffff' : 'transparent',
                color: isLogin ? colors.activeMenu : colors.textMuted,
                boxShadow: isLogin ? '0 4px 12px rgba(0,0,0,0.05)' : 'none'
              }}
            >
              ĐĂNG NHẬP
            </div>
            <div
              onClick={() => setIsLogin(false)}
              className={`auth-tab flex-fill text-center py-2 fw-bold small`}
              style={{
                backgroundColor: !isLogin ? '#ffffff' : 'transparent',
                color: !isLogin ? colors.activeMenu : colors.textMuted,
                boxShadow: !isLogin ? '0 4px 12px rgba(0,0,0,0.05)' : 'none'
              }}
            >
              ĐĂNG KÝ
            </div>
          </div>

          {/* Form Component hiển thị dựa trên Tab (có animation fade-enter) */}
          <div className="fade-enter" key={isLogin ? 'login' : 'signup'}>
            {isLogin ? (
              <Login colors={colors} />
            ) : (
              <Signup colors={colors} changeMode={() => setIsLogin(true)} />
            )}
          </div>

        </div>
      </div>
    </Fragment>
  );
};

export default LoginSignup;